<div class="loader-wrapper" [ngStyle]="{'margin-top': marginTop + 'px'}"><div class="loader"></div></div>